module.exports = __webpack_public_path__ + "img/solo.menu@2x.7631aba1.png";